import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import everAfterLogo from "@/assets/ever-after-logo.png";

export const Footer = () => {
  const venueCategories = [
    { name: "Barn Weddings", link: "/directory?category=venue&style=barn" },
    { name: "Castle Weddings", link: "/directory?category=venue&style=castle" },
    { name: "Country House Weddings", link: "/directory?category=venue&style=stately-home" },
    { name: "Garden & Outdoor Weddings", link: "/directory?category=venue&style=garden-outdoor" },
    { name: "Marquee & Tent Weddings", link: "/directory?category=venue&style=marquee-tent" },
  ];

  const supplierCategories = [
    { name: "Wedding Florists", link: "/directory?category=florist" },
    { name: "Wedding Caterers", link: "/directory?category=caterer" },
    { name: "Wedding Bands", link: "/directory?category=band" },
    { name: "Wedding Decor", link: "/directory?category=decor" },
  ];

  const ukRegions = [
    { name: "London Weddings", link: "/directory?location=London" },
    { name: "Manchester Weddings", link: "/directory?location=Manchester" },
    { name: "Edinburgh Weddings", link: "/directory?location=Edinburgh" },
    { name: "Birmingham Weddings", link: "/directory?location=Birmingham" },
  ];

  return (
    <footer className="border-t bg-card mt-auto">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-6 gap-x-6 gap-y-6 md:gap-8 mb-6 md:mb-8">
          <div className="col-span-2 md:col-span-2 lg:col-span-1 space-y-3">
            <Link to="/" className="flex items-center">
              <img 
                src={everAfterLogo} 
                alt="Ever After List" 
                className="h-14 md:h-24 w-auto object-contain dark:invert"
              />
            </Link>
            <p className="text-sm text-muted-foreground">
              A new UK wedding planning platform, connecting couples with exceptional wedding suppliers and venues.
            </p>
          </div>

          <div>
            <h3 className="font-sans font-semibold text-sm md:text-base mb-2 md:mb-4">Wedding Venues</h3>
            <ul className="space-y-1.5 md:space-y-2 text-sm">
              {venueCategories.map((cat) => (
                <li key={cat.name}>
                  <Link to={cat.link} className="text-muted-foreground hover:text-foreground transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-sans font-semibold text-sm md:text-base mb-2 md:mb-4">Wedding Suppliers</h3>
            <ul className="space-y-1.5 md:space-y-2 text-sm">
              {supplierCategories.map((cat) => (
                <li key={cat.name}>
                  <Link to={cat.link} className="text-muted-foreground hover:text-foreground transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-sans font-semibold text-sm md:text-base mb-2 md:mb-4">By Location</h3>
            <ul className="space-y-1.5 md:space-y-2 text-sm">
              {ukRegions.map((region) => (
                <li key={region.name}>
                  <Link to={region.link} className="text-muted-foreground hover:text-foreground transition-colors">
                    {region.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/find-a-wedding-venue" className="text-muted-foreground hover:text-foreground transition-colors">
                  Find a Wedding Venue
                </Link>
              </li>
              <li>
                <Link to="/directory" className="text-muted-foreground hover:text-foreground transition-colors">
                  View All Locations
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-sans font-semibold text-sm md:text-base mb-2 md:mb-4">Free Tools</h3>
            <ul className="space-y-1.5 md:space-y-2 text-sm">
              <li><Link to="/tools/seating-chart-maker" className="text-muted-foreground hover:text-foreground transition-colors">Free Seating Chart Maker</Link></li>
              <li><Link to="/features/guest-list" className="text-muted-foreground hover:text-foreground transition-colors">Guest List</Link></li>
              <li><Link to="/features/rsvps" className="text-muted-foreground hover:text-foreground transition-colors">Online RSVPs</Link></li>
              <li><Link to="/features/wedding-website" className="text-muted-foreground hover:text-foreground transition-colors">Wedding Website</Link></li>
              <li><Link to="/features/budget" className="text-muted-foreground hover:text-foreground transition-colors">Budget Tracker</Link></li>
              <li><Link to="/features/checklist" className="text-muted-foreground hover:text-foreground transition-colors">Wedding Checklist</Link></li>
              <li><Link to="/wedding-fairs" className="text-muted-foreground hover:text-foreground transition-colors">Wedding Fairs</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-sans font-semibold text-sm md:text-base mb-2 md:mb-4">Company</h3>
            <ul className="space-y-1.5 md:space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-muted-foreground hover:text-foreground transition-colors">
                  Help Centre
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-foreground transition-colors">
                  Wedding Blog
                </Link>
              </li>
              <li>
                <Link to="/business" className="text-muted-foreground hover:text-foreground transition-colors">
                  Join as Supplier
                </Link>
              </li>
              <li>
                <Link to="/business/login" className="text-muted-foreground hover:text-foreground transition-colors">
                  Supplier Login
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t pt-5 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-xs md:text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Ever After List. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
            <Link to="/policies" className="hover:text-foreground transition-colors">All Policies</Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link>
            <Link to="/supplier-terms" className="hover:text-foreground transition-colors">Supplier Terms</Link>
            <Link to="/venue-terms" className="hover:text-foreground transition-colors">Venue Terms</Link>
            <Link to="/cookie-policy" className="hover:text-foreground transition-colors">Cookie Policy</Link>
            <Link to="/data-deletion" className="hover:text-foreground transition-colors">Delete My Data</Link>
          </div>
          <p className="text-xs">
            Website by{" "}
            <a
              href="https://www.webkatie.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-primary hover:underline"
            >
              WebKatie
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
